module.exports = __webpack_public_path__ + "img/comment-action.d876b925.svg";